<div fxLayout="column" [ngStyle]="{ height: !service.arena.loadHigna ? '100%' : null }" class="dataFormClass">
  <div id="fixedGroup" [ngClass]="{ dataFormDefaultStyle: true }">
    <table id="mainGroupTable" [dir]="service.arena.rtlEnabled ? 'rtl' : 'auto'"></table>
  </div>

  <!-- <abcNavMultiView #abcNavMultiView [id]="'abcnav'" [dataSource]="tabs" [visible]=true [swipeEnabled]=true [height]="'100%'" > -->
  <div #tabs id="tabs" class="dataFormTabs" style="display: none"></div>
  <!-- </abcNavMultiView> -->
</div>

<input id="dataFormUploadImageInput" name="Value" hidden class="uploadInput" type="file" #fileInput />

<dx-popup
  #cameraPopup
  [width]="'37%'"
  [height]="'67%'"
  [showTitle]="true"
  title="Kamera"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  container=".dx-viewport"
  class="closeButton"
  (onHiding)="closeCamera()"
>
  <div fxLayout="column" fxFlexOffset="10px">
    <div fxLayout="row" fxFlex="90">
      <video id="video" style="outline: none; width: 99%" autoplay></video>
    </div>
    <div fxLayout="row" fxFlex="10" style="margin-top: 10px">
      <button mat-raised-button id="snap" (click)="capture()">Erfassung</button>
      <canvas id="canvas" hidden></canvas>
    </div>
  </div>
</dx-popup>

<abcLoader [hidden]="!showLoader" [show]="showLoader" [class]="'commentLoader'"></abcLoader>
